import { Observable } from 'rxjs';
import {
  IDeleteGateway,
  IGetGateway,
  ISaveGateway,
  IUploadGateway,
} from '../gateways';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { ILayout } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';

export class LayoutsGateway
  implements
    IGetGateway<null, IApiResponse<ILayout[]>>,
    ISaveGateway<ILayout[], IApiResponse<ILayout[]>>,
    IUploadGateway<FormData, IApiResponse<ILayout[]>>,
    IDeleteGateway<ILayout, IApiResponse<ILayout[]>>
{
  private readonly restCallBuilder: RestCallBuilder<ILayout[]> =
    new RestCallBuilder<ILayout[]>([]);

  get(): Observable<IApiResponse<ILayout[]>> {
    return this.restCallBuilder.get('/layout/').handleMessages().build();
  }

  save(query: ILayout[]): Observable<IApiResponse<ILayout[]>> {
    return this.restCallBuilder
      .post('/layout/', query)
      .handleMessages()
      .build();
  }

  upload(query: FormData): Observable<IApiResponse<ILayout[]>> {
    return this.restCallBuilder
      .upload('/layout', query)
      .handleMessages()
      .build();
  }

  delete(query: ILayout): Observable<IApiResponse<ILayout[]>> {
    return this.restCallBuilder
      .delete('/layout/' + query.id)
      .handleMessages()
      .build();
  }
}
